export default [
  {
    id: 1,
    created_at: '2018-04-10 12:00:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: false,
    type: 'message',
  },
  {
    id: 2,
    created_at: '2018-04-10 12:00:00',
    display: '617-292-2832',
    last_message_at: '2018-07-05 10:32:00',
    message: 'This is the most recent message in the thread',
    read: true,
    sender: true,
    type: 'message',
  },
  {
    id: 3,
    created_at: '2018-04-11 12:00:00',
    display: '617-292-2832',
    last_message_at: '2018-07-05 10:32:00',
    message: 'This is www.github.com next message',
    read: true,
    sender: true,
    type: 'message',
  },
  {
    id: 4,
    created_at: '2018-04-11 12:01:00',
    display: '617-292-2832',
    last_message_at: '2018-07-05 10:32:00',
    message: 'This is next message lorem ipsum',
    read: true,
    sender: true,
    type: 'message',
  },
  {
    id: 5,
    created_at: '2018-04-11 12:01:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    attachment:
      'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    message: null,
    read: false,
    sender: false,
    type: 'message',
  },
  {
    id: 6,
    created_at: '2018-04-12 12:00:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: false,
    type: 'message',
  },
  {
    id: 7,
    created_at: '2018-04-12 12:00:00',
    last_message_at: '2018-07-05 10:32:00',
    message: 'Error Invalid Number. Please re-send using a valid mobile number.',
    read: false,
    sender: false,
    type: 'error',
  },
  {
    id: 8,
    created_at: '2018-04-12 12:01:00',
    display: 'Joe Traveler',
    last_message_at: '2018-07-05 10:32:00',
    attachment:
      'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260',
    message: null,
    read: false,
    sender: true,
    type: 'message',
  },
  {
    id: 9,
    created_at: '2018-04-12 12:10:00',
    display: 'Joe Traveler',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: true,
    type: 'message',
  },
  {
    id: 10,
    created_at: '2018-04-12 12:05:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: false,
    type: 'message',
  },
  {
    id: 11,
    created_at: '2018-04-12 12:10:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: false,
    type: 'message',
  },
  {
    id: 12,
    created_at: '2018-04-13 12:05:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: true,
    type: 'message',
  },
  {
    id: 13,
    created_at: '2018-04-13 12:10:00',
    display: 'Joe Doe',
    last_message_at: '2018-07-05 10:32:00',
    message:
      'This is the most github.com recent message in the thread. This is the most recent message in the thread, This is the most recent message in the thread. This is the most recent message in the thread',
    read: false,
    sender: true,
    type: 'message',
  },
];
